import feathersClient, { makeServicePlugin, BaseModel } from '@/plugins/feathers-client';

class BhCampaignSettings extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'BhCampaignSettings'
  // Define default properties here
  static instanceDefaults() {
    return {
      setting_key: '',
      setting_value: '',
      setting_type: 'NUMBER',
      description: ''
    }
  }
}
const servicePath = 'bh-campaign-settings';
const servicePlugin = makeServicePlugin({
  Model: BhCampaignSettings,
  service: feathersClient.service(servicePath),
  servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
